import type {FunctionTool} from 'openai/resources/responses/responses.mjs';
import * as z from 'zod';

const basePatchOperation = z.object({
  path: z.string().meta({description: 'JSON Pointer path'}),
});

export const patchOperation = basePatchOperation
  .safeExtend({
    op: z.enum(['add', 'replace', 'test']),
    value: z.any(),
  })
  .or(
    basePatchOperation.safeExtend({
      op: z.enum(['remove']),
    })
  )
  .or(
    basePatchOperation.safeExtend({
      op: z.enum(['move', 'copy']),
      from: z.string(),
    })
  );

export const updateLessonToolParameters = z.object({
  patch: patchOperation.array().meta({
    description:
      'RFC 6902 JSON Patch operations to transform the current lesson. Use JSON Pointer paths (0-indexed arrays).',
  }),
});

export const updateLessonTool = {
  type: 'function',
  name: 'updateLesson',
  description: 'Propose JSON Patch operations to update the lesson.',
  parameters: z.toJSONSchema(updateLessonToolParameters),
  strict: false,
} as const satisfies FunctionTool;
